// Login 2027 — porta do auth.js / auth-mobile.js do demo (onesalesdashboard.netlify.app/login.html),
// ligado às rotas de sempre: /login/login, /login/verify-2fa, /login/resend-2fa, /login/forgotPassword.
// Uma linha, cinco turnos (e-mail, senha, código, recuperar, enviado): a etapa de e-mail é só visual,
// o backend recebe e-mail + senha juntos no turno da senha, e o código só existe se ele responder `two_factor`.
// jQuery vem global do Metronic. HOST_URL, CSRF_TOKEN e ENVIRONMENT vêm do main.blade.php.
const $ = window.jQuery;
const { default: axios } = require('axios');

const Login = function () {

    const RESEND_SECONDS = 60;
    const MIN_SENHA = 6;   // mesma regra do LoginController (password min:6)
    const CONVITE = 'Escreva seu e-mail aqui';
    const MSG_COMUNICACAO = 'Erro de comunicação, por favor, recarregue a página';

    let $auth;
    let step = 'email';
    let email = '';
    let timer = null;
    let busy = false;
    let montado = false;   // a abertura não reescreve: o convite do campo já está datilografando

    // ------------------------------------------------------------------ requisição
    const post = function (path, data) {
        return axios.post(HOST_URL + path, new URLSearchParams(data), {
            headers: { 'X-CSRF-TOKEN': CSRF_TOKEN, 'X-Requested-With': 'XMLHttpRequest' }
        }).then(function (res) { return res.data; });
    };

    const msg = function (m) { return Array.isArray(m) ? m.join(' ') : m; };

    // ------------------------------------------------------------------ reescrita (typewriter fora do campo)
    // O tempo é do gesto, não do caractere: a frase leva `dur` ms com 12 ou 40 letras.
    const ESCREVE = {
        linear: null,
        apagando: function (k) { return k * k; }
    };

    const escreveAte = function (el, texto, n0, n1, dur, curva, pronto) {
        let ini = null, id = 0, vivo = true;
        const frame = function (t) {
            if (!vivo) return;
            if (ini === null) ini = t;
            let k = dur > 0 ? Math.min(1, (t - ini) / dur) : 1;
            if (curva) k = curva(k);
            el.textContent = texto.slice(0, Math.round(n0 + (n1 - n0) * k));
            if (k < 1) { id = requestAnimationFrame(frame); return; }
            if (pronto) pronto();
        };
        el.textContent = texto.slice(0, n0);   // estado inicial síncrono: sem estalo do texto novo inteiro
        id = requestAnimationFrame(frame);
        return function () { vivo = false; cancelAnimationFrame(id); };
    };

    // Duração × escala do painel (zera com prefers-reduced-motion). Lê da tela: --mo-* moram em .auth.
    const msMotion = function (nome) {
        const cs = getComputedStyle($auth[0]);
        const base = parseFloat(cs.getPropertyValue(nome)) || 0;
        const esc = parseFloat(cs.getPropertyValue('--mo-escala'));
        return base * (isNaN(esc) ? 1 : esc);
    };

    // Convite do campo de e-mail: escreve uma vez e pisca; ao focar, fica o texto sem cursor falso
    const convidar = function (input, texto) {
        let c = 0, timerC = null, blink = null, paused = false;
        const clearBlink = function () { if (blink) { clearInterval(blink); blink = null; } };
        const passo = function () {
            if (paused) return;
            c++;
            input.placeholder = texto.slice(0, c) + '_';
            if (c >= texto.length) {
                let on = true;
                clearBlink();
                blink = setInterval(function () { on = !on; input.placeholder = texto + (on ? '_' : ' '); }, 420);
                return;
            }
            timerC = setTimeout(passo, 55);
        };
        const stop = function () { paused = true; clearTimeout(timerC); clearBlink(); };
        const start = function () { if (!paused) return; paused = false; passo(); };
        input.addEventListener('focus', function () { stop(); input.placeholder = texto; });
        input.addEventListener('blur', function () { if (!input.value) { paused = true; c = 0; start(); } });
        passo();
        return { stop: stop, start: start };
    };

    // ------------------------------------------------------------------ turnos
    let gerTroca = 0;      // geração: clique rápido cancela a reescrita anterior
    let cancelas = [];
    let relogio = null;

    const paraReescrita = function () {
        gerTroca++;
        cancelas.forEach(function (c) { c(); });
        cancelas = [];
        clearTimeout(relogio); relogio = null;
    };

    // Rótulos reescrevíveis de um turno; o texto original fica em data-texto na primeira leitura
    const rotulos = function (turno) {
        const els = [];
        $auth.find('[data-escreve]').each(function () {
            const pane = this.closest('[data-step]');
            if (!pane || pane.dataset.step !== turno) return;
            if (this.dataset.texto == null) this.dataset.texto = this.textContent;
            els.push(this);
        });
        return els;
    };

    const focusSoon = function (sel) { setTimeout(function () { $(sel).trigger('focus'); }, 220); };

    const show = function (next) {
        const sai = rotulos(step);
        paraReescrita();
        const g = gerTroca;
        const tApaga = msMotion('--mo-apaga');
        const tVira = msMotion('--mo-vira');

        // Aba escondida não recebe quadros: entra direto, senão a navegação trava no meio do apagar
        if (!montado || document.hidden || tApaga <= 0 || !sai.length) { aplica(next, g); return; }

        let faltam = sai.length;
        sai.forEach(function (el) {
            el.dataset.escrevendo = 'true';
            cancelas.push(escreveAte(el, el.dataset.texto, el.textContent.length, 0, tApaga, ESCREVE.apagando, function () {
                if (g !== gerTroca || --faltam) return;
                relogio = setTimeout(function () { aplica(next, g); }, tVira);
            }));
        });
    };

    const aplica = function (next, g) {
        if (g != null && g !== gerTroca) return;
        step = next;
        $auth.find('.head-pane, .field-pane, .note-pane').each(function () {
            this.dataset.active = (this.dataset.step === next) ? 'true' : 'false';
        });

        // Rótulo que não é deste turno volta inteiro (uma reescrita cancelada deixa texto pela metade)
        const entra = rotulos(next);
        $auth.find('[data-escreve]').each(function () {
            if (entra.indexOf(this) >= 0) return;
            delete this.dataset.escrevendo;
            if (this.dataset.texto != null) this.textContent = this.dataset.texto;
        });

        const tEscreve = msMotion('--mo-reescreve');
        entra.forEach(function (el) {
            if (!montado || document.hidden || tEscreve <= 0) { delete el.dataset.escrevendo; el.textContent = el.dataset.texto; return; }
            el.dataset.escrevendo = 'true';
            cancelas.push(escreveAte(el, el.dataset.texto, 0, el.dataset.texto.length, tEscreve, ESCREVE.linear, function () {
                delete el.dataset.escrevendo;
            }));
        });

        clearError();
        stopResend();

        if (next === 'email') focusSoon('#email');
        if (next === 'senha') {
            $('[data-step="senha"] [data-ident]').text(email);
            $('#senha').val('');
            ready($('#lineSenha'), false);
            focusSoon('#senha');
        }
        if (next === 'codigo') {
            $('[data-step="codigo"] [data-ident]').text(email);
            clearCode();
            startResend();
            setTimeout(function () { $auth.find('.code input').first().trigger('focus'); }, 220);
        }
        // O e-mail já digitado vai junto para a recuperação
        if (next === 'recuperar') {
            const digitado = email || $('#email').val().trim();
            if (digitado) { $('#recEmail').val(digitado); ready($('#lineRecuperar'), validEmail(digitado)); }
            focusSoon('#recEmail');
        }
        if (next === 'enviado') $('[data-step="enviado"] [data-ident]').text($('#recEmail').val().trim());
    };

    // ------------------------------------------------------------------ erro e linha
    const showError = function ($line, m, tone) {
        if ($line) $line.attr('data-error', 'true');
        $('#errNote').text(msg(m)).attr('data-tone', tone || 'alert').attr('data-show', 'true');
    };

    const clearError = function () {
        $auth.find('.line-field').attr('data-error', 'false');
        $auth.find('.code').attr('data-error', 'false');
        $('#errNote').attr('data-show', 'false').text('');
    };

    const ready = function ($line, on) { $line.attr('data-ready', on ? 'true' : 'false'); };
    const loading = function ($btn, on) { $btn.attr('data-loading', on ? 'true' : 'false'); };

    // Falha de rede: mesma regra de sempre, recarrega fora do ambiente dev
    const falhaComunicacao = function ($line, recarrega) {
        showError($line, MSG_COMUNICACAO);
        if (recarrega && ENVIRONMENT != 'dev') setTimeout(function () { location.reload(); }, 1000);
    };

    const validEmail = function (v) { return /^\S+@\S+\.\S+$/.test(v.trim()); };

    // A linha: o avanço só aparece quando há o que avançar
    // `turno`: a linha só reage no próprio turno (o autofill do navegador preenche campos de turnos escondidos e dispara `input`)
    const wireLine = function (lineId, inputId, turno, validate, submit) {
        const $line = $('#' + lineId);
        const $input = $('#' + inputId);
        const $go = $line.find('.go-btn');

        $input.on('input', function () {
            if (step !== turno) return;
            clearError(); ready($line, validate(this.value));
        });
        $input.on('keydown', function (e) {
            if (e.key === 'Enter') { e.preventDefault(); if (step === turno) submit($line, $input, $go); }
        });
        $go.on('click', function () { if (step === turno) submit($line, $input, $go); });
    };

    // ------------------------------------------------------------------ e-mail e senha
    const submitEmail = function ($line, $input) {
        if (!validEmail($input.val())) {
            showError($line, 'Esse e-mail não parece completo.');
            $input.trigger('focus'); return;
        }
        email = $input.val().trim();
        show('senha');
    };

    const submitSenha = function ($line, $input, $go) {
        if (!$input.val()) { showError($line, 'Digite sua senha.'); $input.trigger('focus'); return; }
        // O backend exige 6+ caracteres e responde só "E-mail e senha não enviados": quem ainda não tem senha (1º acesso) cai aqui
        if ($input.val().length < MIN_SENHA) {
            showError($line, 'Senha incorreta. No primeiro acesso, use “Primeiro acesso ou Esqueceu a senha?” para criar a sua.');
            $input.trigger('focus'); return;
        }
        if (busy) return;
        busy = true;
        loading($go, true);
        let redirecionando = false;

        post('/login/login', { email: email, password: $input.val() }).then(function (data) {
            if (data.error) {
                showError($line, data.message);
                $input.val('').trigger('focus');
                ready($line, false);
            } else if (data.two_factor) {
                show('codigo');
            } else if (data.result && data.result.link) {
                redirecionando = true;
                window.location = data.result.link;
            } else {
                redirecionando = true;
                location.reload();
            }
        }).catch(function () {
            falhaComunicacao($line, true);
        }).then(function () {
            busy = false;
            if (!redirecionando) loading($go, false);
        });
    };

    // ------------------------------------------------------------------ recuperar senha
    const submitRecuperar = function ($line, $input, $go) {
        if (!validEmail($input.val())) {
            showError($line, 'Esse e-mail não parece completo.');
            $input.trigger('focus'); return;
        }
        if (busy) return;
        busy = true;
        loading($go, true);

        post('/login/forgotPassword', { email: $input.val().trim() }).then(function (data) {
            if (data.error) showError($line, data.message);
            else show('enviado');
        }).catch(function () {
            falhaComunicacao($line, true);
        }).then(function () {
            busy = false;
            loading($go, false);
        });
    };

    // ------------------------------------------------------------------ código de 6 dígitos
    const codeInputs = function () { return $auth.find('.code input'); };
    const codeValue = function () { return codeInputs().map(function () { return this.value; }).get().join(''); };

    const syncCode = function () {
        codeInputs().each(function () { this.dataset.filled = this.value ? 'true' : 'false'; });
    };

    const clearCode = function () {
        $auth.find('.code').attr('data-error', 'false');
        codeInputs().each(function () { this.value = ''; this.dataset.filled = 'false'; });
    };

    // Espalha os dígitos a partir de uma caixa: colar, preenchimento automático ou digitação rápida
    const distribute = function (digits, startIdx) {
        const inputs = codeInputs();
        for (let k = 0; k < digits.length && startIdx + k < inputs.length; k++) {
            inputs[startIdx + k].value = digits[k];
        }
        syncCode();
        inputs[Math.min(startIdx + digits.length, inputs.length - 1)].focus();
        if (codeValue().length === 6) verify();
    };

    const wireCode = function () {
        const inputs = codeInputs();
        inputs.each(function (idx) {
            $(this).on('input', function () {
                clearError();
                const digits = this.value.replace(/\D/g, '');
                this.value = '';
                if (!digits) { syncCode(); return; }
                distribute(digits, idx);
            });
            $(this).on('keydown', function (e) {
                if (e.key === 'Backspace' && !this.value && idx > 0) {
                    inputs[idx - 1].focus(); inputs[idx - 1].value = ''; syncCode(); e.preventDefault();
                }
                if (e.key === 'ArrowLeft' && idx > 0) inputs[idx - 1].focus();
                if (e.key === 'ArrowRight' && idx < inputs.length - 1) inputs[idx + 1].focus();
            });
            $(this).on('paste', function (e) {
                e.preventDefault();
                const clip = (e.originalEvent.clipboardData || window.clipboardData).getData('text');
                const txt = clip.replace(/\D/g, '').slice(0, 6);
                if (!txt) return;
                clearError();
                distribute(txt, 0);
            });
            $(this).on('focus', function () { this.select(); });
        });
    };

    const codigoInvalido = function (m) {
        $auth.find('.code').attr('data-error', 'true');
        showError(null, m);
        // Limpa e devolve o cursor ao início: ninguém quer caçar qual dígito errou
        setTimeout(function () {
            codeInputs().each(function () { this.value = ''; this.dataset.filled = 'false'; });
            codeInputs().first().trigger('focus');
        }, 420);
    };

    const verify = function () {
        if (codeValue().length !== 6 || busy) return;
        busy = true;

        post('/login/verify-2fa', { code: codeValue() }).then(function (data) {
            if (data.error) {
                if (data.result && data.result.link) { window.location = data.result.link; return; }
                codigoInvalido(data.message);
            } else {
                window.location = data.result.link;
            }
        }).catch(function () {
            codigoInvalido(MSG_COMUNICACAO);
        }).then(function () {
            busy = false;
        });
    };

    // ------------------------------------------------------------------ reenvio
    const startResend = function () {
        let left = RESEND_SECONDS;
        const $wrap = $('#resend');
        stopResend();
        const paint = function () {
            $wrap.html(left > 0
                ? 'Não recebeu? Reenviar em <span class="num">' + left + 's</span>'
                : 'Não recebeu? <button type="button" id="btnResend">Reenviar código</button>');
        };
        paint();
        timer = setInterval(function () { left--; paint(); if (left <= 0) clearInterval(timer); }, 1000);
    };

    const stopResend = function () { if (timer) clearInterval(timer); timer = null; };

    const resend = function () {
        const $btn = $('#btnResend').prop('disabled', true);
        post('/login/resend-2fa', {}).then(function (data) {
            if (data.error) {
                if (data.result && data.result.link) { window.location = data.result.link; return; }
                showError(null, data.message);
                $btn.prop('disabled', false);
                return;
            }
            clearCode(); clearError(); startResend();
            showError(null, data.message, 'ok');
            codeInputs().first().trigger('focus');
        }).catch(function () {
            showError(null, 'Erro de comunicação, por favor, tente novamente.');
            $btn.prop('disabled', false);
        });
    };

    // ------------------------------------------------------------------ mobile
    // Foto do cliente com dois tamanhos: capa (chegada) e banda (digitando, o teclado come ~336px).
    // Quem decide é "a pessoa ainda está no formulário", não :focus-within (o foco automático recolheria a capa).
    const Mobile = function () {
        const mq = matchMedia('(max-width: 767px)');
        const PAUSA = 900;   // maior troca de turno (700ms de rede típica + 220ms do foco); menos que isso a capa volta no meio do caminho
        let gesto = false;
        let volta = null;

        const mobile = function () { return mq.matches; };
        const fixar = function (v) { clearTimeout(volta); volta = null; $auth.attr('data-estado', v); };
        const noForm = function (el) { return !!(el && el.closest && el.closest('.auth-form')); };

        const repousar = function () {
            if (mobile()) $auth.attr('data-estado', 'capa');
            else { clearTimeout(volta); volta = null; $auth.removeAttr('data-estado'); }
        };

        const sincronizar = function () {
            if (!mobile()) { repousar(); return; }
            if (!gesto) { fixar('capa'); return; }
            if (noForm(document.activeElement)) { fixar('banda'); return; }
            // Trocar de turno passa por um instante sem foco: a volta à capa é adiada
            clearTimeout(volta);
            volta = setTimeout(function () { $auth.attr('data-estado', 'capa'); }, PAUSA);
        };

        return {
            init: function () {
                document.addEventListener('focusin', function (e) {
                    if (!mobile()) return;
                    // Antes do primeiro gesto nenhum foco se segura: no telefone, foco automático chama o teclado
                    if (!gesto && e.target && e.target.blur) { e.target.blur(); return; }
                    sincronizar();
                }, true);
                document.addEventListener('focusout', function () { setTimeout(sincronizar, 0); });
                document.addEventListener('pointerdown', function (e) {
                    gesto = true;
                    if (!mobile()) return;
                    fixar(noForm(e.target) ? 'banda' : 'capa');
                }, true);

                const virou = function () { gesto = false; repousar(); };
                if (mq.addEventListener) mq.addEventListener('change', virou);
                else if (mq.addListener) mq.addListener(virou);

                repousar();

                // Foco antes do primeiro gesto só pode ter vindo de código: o gesto é toque, tecla ou 1,5s
                const liberar = function () { gesto = true; };
                ['touchstart', 'keydown'].forEach(function (ev) {
                    document.addEventListener(ev, liberar, { capture: true, once: true });
                });
                setTimeout(liberar, 1500);
            }
        };
    }();

    // ------------------------------------------------------------------ marca do cliente
    // Sem a foto/logo do cliente, o painel fica na tinta do sistema com o monograma
    const initBrand = function () {
        const $brand = $auth.find('.client-brand');
        const $bg = $auth.find('.auth-brand img.bg');
        const miss = function (el) { return function () { el.attr('data-missing', ''); }; };

        $brand.find('img').each(function () {
            if (this.complete) { if (!this.naturalWidth) miss($brand)(); return; }
            this.addEventListener('error', miss($brand));
        });
        $bg.on('error', miss($auth.find('.auth-brand')));
        if ($bg[0].complete && !$bg[0].naturalWidth) miss($auth.find('.auth-brand'))();
    };

    return {
        init: function () {
            $auth = $('.auth');
            if (!$auth.length) return;

            initBrand();

            wireLine('lineRecuperar', 'recEmail', 'recuperar', validEmail, submitRecuperar);
            wireLine('lineEmail', 'email', 'email', validEmail, submitEmail);
            wireLine('lineSenha', 'senha', 'senha', function (v) { return !!v; }, submitSenha);
            wireCode();

            convidar(document.getElementById('email'), CONVITE);

            // Links de nota e botões "trocar": o data-go nomeia o turno
            $auth.on('click', 'a[data-go]', function (e) {
                e.preventDefault();
                if (this.dataset.go === 'email') $('#senha').val('');
                show(this.dataset.go);
            });
            $auth.on('click', 'button[data-go="email"]', function () {
                $('#senha').val('');
                show('email');
            });

            $auth.on('click', '#btnResend', resend);

            $auth.find('.reveal').on('click', function () {
                const $f = $('#senha');
                const shown = $f.attr('type') === 'text';
                $f.attr('type', shown ? 'password' : 'text');
                $(this).find('.ai').attr('class', 'ai ai-' + (shown ? 'eye' : 'eye-slash'));
                $(this).attr('aria-label', shown ? 'Mostrar senha' : 'Ocultar senha');
                $f.trigger('focus');
            });

            // Esc volta um passo
            $(document).on('keydown', function (e) {
                if (e.key !== 'Escape') return;
                if (step === 'codigo') show('senha');
                else if (step === 'senha') show('email');
            });

            Mobile.init();
            show('email');
            montado = true;
        }
    };
}();

module.exports = Login;

$(() => Login.init());
